import { render, staticRenderFns } from "./pseudoaleatorio.vue?vue&type=template&id=146d350b&scoped=true"
import script from "./pseudoaleatorio.vue?vue&type=script&lang=js"
export * from "./pseudoaleatorio.vue?vue&type=script&lang=js"
import style0 from "./pseudoaleatorio.vue?vue&type=style&index=0&id=146d350b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146d350b",
  null
  
)

export default component.exports